import React from 'react';
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import useTheme from "@material-ui/core/styles/useTheme";
import useMediaQuery from "@material-ui/core/useMediaQuery";

const useStyles = makeStyles((theme) => ({
    footer: {
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(6, 0),
        marginTop: 'auto',
        borderTop: `1px solid ${theme.palette.divider}`,
    },
    container: {
        maxWidth: theme.maxContentWidth,
        margin: '0 auto',
        padding: theme.spacing(0, 2),
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: theme.spacing(2),
    },
    socialLinks: {
        display: 'flex',
        gap: theme.spacing(2),
    },
    socialIcon: {
        color: theme.palette.text.secondary,
        '&:hover': {
            color: theme.palette.primary.main,
        },
    },
    links: {
        display: 'flex',
        gap: theme.spacing(3),
        flexWrap: 'wrap',
        justifyContent: 'center',
    },
    link: {
        color: theme.palette.text.secondary,
        textDecoration: 'none',
        '&:hover': {
            color: theme.palette.primary.main,
        },
    },
    copyright: {
        color: theme.palette.text.secondary,
        textAlign: 'center',
    },
}));

const Footer = () => {
    const classes = useStyles();
    const { t } = useTranslation();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <footer className={classes.footer}>
            <div className={classes.container}>
                <Box className={classes.content}>
                    <Box className={classes.socialLinks}>
                        <IconButton
                            className={classes.socialIcon}
                            component="a"
                            href="https://www.facebook.com/share/1YoCLAaHGT/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img 
                                src="https://www.facebook.com/images/fb_icon_325x325.png" 
                                alt="Facebook"
                                style={{ width: 24, height: 24 }}
                            />
                        </IconButton>
                        <IconButton
                            className={classes.socialIcon}
                            component="a"
                            href="https://www.instagram.com/agendia.mx"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img 
                                src="https://www.instagram.com/static/images/ico/favicon-200.png/ab6eff595bb1.png" 
                                alt="Instagram"
                                style={{ width: 24, height: 24 }}
                            />
                        </IconButton>
                    </Box>

                    <Box className={classes.links}>
                        <Link to="/terms" className={classes.link}>
                            <Typography variant="body2">
                                {t('terms_and_conditions')}
                            </Typography>
                        </Link>
                        <Link to="/privacy" className={classes.link}>
                            <Typography variant="body2">
                                {t('privacy_policy')}
                            </Typography>
                        </Link>
                        <Link to="/contact" className={classes.link}>
                            <Typography variant="body2">
                                {t('contact_us')}
                            </Typography>
                        </Link>
                    </Box>

                    <Typography variant="body2" className={classes.copyright}>
                        © {new Date().getFullYear()} {t('app_name')}. {t('all_rights_reserved')}
                    </Typography>
                </Box>
            </div>
        </footer>
    );
};

export default Footer; 